import {
  DELETE_TIMER_INFO,
  UPDATE_TIMER_INFO
} from "../constants/doctorsQueue";

const initialState = {
  timers: {}
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case UPDATE_TIMER_INFO:
      let newArr1 = { ...state.timers };
      newArr1[action.payload._id] = action.payload;
      return {
        ...state,
        timers: newArr1
      };
    case DELETE_TIMER_INFO:
      let newArr2 = { ...state.timers };
      delete newArr2[action.payload._id];
      return {
        ...state,
        timers: newArr2 ? newArr2 : {}
      };

    default:
      return state;
  }
}
